// extracted by mini-css-extract-plugin
module.exports = {"hero":"Projects_hero__1hoFR","selectedWork":"Projects_selectedWork__3QZrq","selectedWorkList":"Projects_selectedWorkList__qXUoA"};